
import { useMutation, useQuery } from 'react-query';
import { addFarmInfo, getAssignedFarmUsers, getFarmInfo, getProdPlacesByFarm, inviteFarmUsers, selfAddFarm, selfAddProdPlace, updateFarm } from 'api/farms';
import { AddFarmData, GetAssignedFarmUsersData, GetProdPlacesByFarmData } from 'types';

export const useGetFarmInfo = () => {

  return useMutation((params: {id: string | number}) => getFarmInfo(params));

}

export const useGetAssignedFarmUsers = () => {

  return useMutation((params: {id: string | number}) => getAssignedFarmUsers(params));

}

export const useGetAssignedFarmUsersQuery = (farmId: string | null) => {
  return useQuery<GetAssignedFarmUsersData>(
    ['assigned-farm-users', farmId || ''],
    () => getAssignedFarmUsers({ id: farmId || '' }),
    {
      enabled: Boolean(farmId),
      staleTime: 60 * 1000,
    }
  );
}

export const useGetProdPlacesByFarmQuery = (farmId: string | null) => {
  return useQuery<GetProdPlacesByFarmData>(
    ['prod-places-by-farm', farmId || ''],
    () => getProdPlacesByFarm({ farmId: farmId || '' }),
    {
      enabled: Boolean(farmId),
      staleTime: 60 * 1000,
    }
  );
}

export const useAddFarmInfo = () => {

  return useMutation((params: AddFarmData) => addFarmInfo(params));

}

export const useSelfAddFarm = () => {

  return useMutation((params: any) => selfAddFarm(params));

}

export const useSelfAddProdPlace = () => {

  return useMutation((params: any) => selfAddProdPlace(params));

}

export const useUpdateFarm = () => {

  return useMutation((params: any) => updateFarm(params));

}

export const useInviteFarmUsers = () => {

  return useMutation((userEmails: string[]) => inviteFarmUsers(userEmails));

}
